import { Client, setup } from './allauth';
import { getAllauthBaseUrl } from './config';
import { isBookingHost } from './scheduling/bookingHosts';

export function initAllauth(): void {
  if (!isBookingHost()) {
    setup(Client.BROWSER, getAllauthBaseUrl(), true);
  }
}
